import * as __NgCli_bootstrap_1 from "@angular/platform-browser";
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { getStaticAppSettings } from './staticAppSettings';
import { loadNewRelic } from './newrelic.browser';
void getStaticAppSettings().then(() => {
    // @ts-ignore
    if (/prod|rc/i.test(window.APP_SETTINGS.ENV)) {
        enableProdMode();
    }
    loadNewRelic()
        .catch((err) => { console.error(err); })
        .finally(() => {
        // Now bootstrap Angular
        __NgCli_bootstrap_1.platformBrowser()
            .bootstrapModule(AppModule)
            .catch(err => console.error(err));
    });
});
